import React from 'react';
import { Box, Button, Theme, Typography, useMediaQuery } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { COLOR_WHITE } from '@monorepo/shared/src/themes/studentAppTheme';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import assignmentsBackground from 'assets/images/assignments-background.png';
import assignmentsCopies from 'assets/images/assignments-copies.png';
import assignmentCountImage from 'assets/images/assignment_count.png';
import assignmentsQuinn from 'assets/images/assignments-quinn.png';
import useAssignmentsStore from 'graph/state/query-hooks/use-assignments-store';
import { ASSIGNMENT_STATUSES } from '../../Assignments/types';

const t = (key: string) => translate('a11y', key);
const tHome = (key: string) => translate('home', key);

type StylesProps = {
  assignmentCountImage: string;
};

type Props = {
  onClick: any;
  styles: { [key: string]: any };
  components: any;
};

const AssignmentsIcon: React.FC<Props> = ({ onClick, styles, components }) => {
  const [{ assignments }] = useAssignmentsStore();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.between('xs', 'md'));
  const classes = useStyles({
    assignmentCountImage: assignmentCountImage,
  });

  const newAssignments = assignments?.filter(
    ({ status }) => status === ASSIGNMENT_STATUSES.NEW
  )?.length;

  return (
    <Box
      className={`${classes.assignmentsAndQuinn} ${isMobile ? classes.scale : ''}`}
      style={styles}
    >
      <Button
        className={`${classes.button} ${classes.assignmentsBtn}`}
        disableTouchRipple
        onClick={onClick}
      >
        <div className={classes.assignmentsBackgroundImg}>
          <img alt={t('alt.assignments')} className={classes.assignments} src={assignmentsCopies} />
          {newAssignments ? (
            <div className={classes.assignmentCount}>
              <Typography variant="h2" className={classes.assignmentCountText}>
                {newAssignments}
              </Typography>
            </div>
          ) : null}

          <Typography variant="h1" className={classes.assignmentsText}>
            {tHome('assignments')}
          </Typography>
        </div>
      </Button>
      <img alt={t('alt.quinn')} className={classes.assignmentsQuinn} src={assignmentsQuinn} />
      {components && <div>{components}</div>}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  assignmentsAndQuinn: {
    position: 'absolute',
    right: 'calc(20vw + 520px)',
    top: '30vh',
  },
  assignmentCount: {
    backgroundImage: ({ assignmentCountImage }: StylesProps) => `url(${assignmentCountImage})`,
    left: remCalc(240),
    position: 'absolute',
    top: remCalc(15),
    width: remCalc(72),
    height: remCalc(72),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  assignmentCountText: {
    color: COLOR_WHITE,
    fontFamily: 'MM Futura Semi Bold',
    fontWeight: 'bold',
  },
  assignments: {
    left: remCalc(30),
    position: 'absolute',
    top: remCalc(15),
  },
  assignmentsBtn: {
    left: remCalc(0),
    position: 'absolute',
    top: remCalc(0),
  },
  assignmentsBackgroundImg: {
    backgroundImage: `url(${assignmentsBackground})`,
    height: remCalc(310),
    width: remCalc(302),
  },
  assignmentsText: {
    color: COLOR_WHITE,
    left: remCalc(35),
    position: 'absolute',
    top: remCalc(120),
  },
  assignmentsQuinn: {
    left: remCalc(290),
    position: 'absolute',
    top: remCalc(50),
  },
  button: {
    '&:hover': {
      background: 'none',
    },
  },
  scale: {
    right: `${remCalc(440)} !important`,
    top: '31vh !important',
    transform: 'scale(0.85)',
  },
}));

export default AssignmentsIcon;
